import React, { useEffect, useState } from 'react'

import { Grid, TextField, Typography } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import useSnackbar from 'hooks/useSnackbar'
import useSupplierJourney from 'hooks/useSupplierJourney'

import { ConfirmationDialog } from 'components'
import * as service from 'service'
import helpers from 'helpers'

const ConfirmDataForm = ({ setIsLoading }) => {
  const { handleSubmit, control, errors } = useFormContext()
  const snackbar = useSnackbar()
  const {
    handleNext,
    accessToken,
    setAccessToken,
    user,
    setUser,
    companySupplierToken,
  } = useSupplierJourney()

  const [openConfirmation, setOpenConfirmation] = useState(false)
  const [pendingData, setPendingData] = useState(null)
  const [confirmLoading, setConfirmLoading] = useState(false)

  const onSubmit = (data) => {
    setPendingData(data)
    setOpenConfirmation(true)
  }

  const handleConfirm = async () => {
    try {
      setConfirmLoading(true)
      setIsLoading(true)

      const response =
        await service.supplierPortal.companySuppliers.confirmData({
          token: companySupplierToken,
          name: pendingData?.name,
          email: pendingData?.email,
        })

      setUser(response?.data?.user)
      setAccessToken(response?.data?.accessToken)
      setOpenConfirmation(false)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao confirmar seus dados. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setConfirmLoading(false)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!user || !accessToken) return

    handleNext()
  }, [!!user, !!accessToken])

  return (
    <>
      <Grid item xs={12} md={8}>
        <Typography
          variant="h2"
          color="primary"
          style={{ textAlign: 'center' }}
        >
          Confirme seus Dados
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography
          variant="h4"
          style={{ fontWeight: 400, textAlign: 'center' }}
          color="primary"
        >
          Para finalizar seu cadastro, confirme o nome da sua organização e o
          seu e-mail. Se necessário, atualize as informações abaixo.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <form id="form-register" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} md={8}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    label="Razão Social"
                    error={!!errors?.name}
                    helperText={errors?.name?.message}
                  />
                }
                name="name"
                control={control}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    label="E-mail"
                    error={!!errors?.email}
                    helperText={errors?.email?.message}
                  />
                }
                name="email"
                control={control}
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
      <ConfirmationDialog
        open={openConfirmation}
        setOpen={setOpenConfirmation}
        text="Atenção! Após avançar, seus dados não poderão ser alterados. Caso precise de ajuda, entre em contato com a empresa responsável."
        textButton="Confirmar"
        textButtonCancel="Voltar"
        actionAcceptButton={handleConfirm}
        loading={confirmLoading}
        disableBackdropClick
      />
    </>
  )
}

export default ConfirmDataForm
